import { Injectable, Injector } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { WidgetsAbstract } from "src/app/abstract/widgets/widgets.abstract";
import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import { Logger } from "src/app/core/logger";
import { RenderService } from "./render.service";
import { AbstractRender } from "src/app/abstract/render.abstract";

@Injectable({
  providedIn: 'root'
})
export class RenderFormService extends AbstractRender {
  constructor(
    private injector: Injector,
    private logger: Logger
  ) {
    super();
  }

  /**
   * Recursive render method
   *
   * @param widget A layout node
   * @param config Formly field config array
   * @param widgetRoot Root of the layout
   * @param formlyRoot Root of the FormlyFieldConfig
   * @param isInsideQuestion True if we are rendering a subtree inside a question
   * @param isRecursive True if we want to traverse the tree to the bottom. False if we just want to render a node.
   */
  render(widget: WidgetsAbstract,
    config: FormlyFieldConfig[],
    widgetRoot: WidgetsAbstract,
    formlyRoot: FormlyFieldConfig,
    isInsideQuestion: boolean,
    isRecursive: boolean ) {
    let field: FormlyFieldConfig;

    try {
      if (widget instanceof WidgetsFormModel) {
          const formWidget = widget as WidgetsFormModel;
          isInsideQuestion = false;
          if (isInsideQuestion) {
            // We are dealing with a Question here
            const sequence = formWidget.name;

            // FIXME: Done. For now just add the $seq label to the name as title
            // if (formWidget.labelOverrides) {
            //   sequence = formWidget.labelOverrides.get("$seq") + ". " + formWidget.name;
            // }
            field = {
              props: {
                label: formWidget.name
              },
              fieldGroup: []
            };
          } else {
            field = {
              // type: 'flex-layout',
              props: {
                description: 'FORM',
                // fxLayout: 'column',
                // fxLayoutGap: '20px grid',
              },
              fieldGroup: []
            };
          }

          // Mix created input with widget template
          if (formWidget.template) {
            const modelTemplate = JSON.parse(formWidget.template);
            field = Object.assign({}, field, modelTemplate);
          }

          config.push(field);
          // END

          // widgetRoot overwritten with FORM
          if (isRecursive) {
            const renderService = this.injector.get(RenderService);
            formWidget.children.forEach(childWidget => {
              // eslint-disable-next-line
              renderService.render(childWidget, field.fieldGroup!, widget, formlyRoot, isInsideQuestion, isRecursive);
            });
          }
      }
    } catch (error) {
      this.logger.log(error);
    }
  }
}
